import DottedLoader from '../dotted-loader/index.vue';

export default {
  render(createElement) {
    const vm = this;
    let tagName;
    const elementOptions = {
      class: {
        'button': true,
        'button--small': !!this.small,
        'button--bg_second-color': this.secondColor || false,
        'button--contrast': this.contrast || false,
        'button--weight-normal': this.thinText || false,
        'button--outline': this.outline || false,
        'button--dashed': this.dashed || false,
        'button--disabled': this.disabled || false,
      },
      on: {
        click(e) {
          e.preventDefault();
          if (vm.loader) return;
          vm.$emit('click', e);
        },
        enter(e) {
          if (vm.loader) return;
          vm.$emit('enter', e);
        },
      },
      attrs: {
        tabindex: '1',
      },
    };

    if (this.href && this.isRouterLink) {
      tagName = 'router-link';
      Object.assign(elementOptions.attrs, { to: this.href });
    } else if (this.href) {
      tagName = 'a';
      Object.assign(elementOptions.attrs, { href: this.href });
    } else {
      Object.assign(elementOptions.attrs, { type: this.type });
      tagName = 'button';
    }

    return createElement(tagName, elementOptions, this.loader ? [createElement(DottedLoader)] : this.$slots.default);
  },
  name: 'rzButton',
  components: {
    DottedLoader,
  },
  props: {
    href: {
      type: [String, Object],
      default: null,
    },
    type: {
      type: String,
      default: 'button',
    },
    small: Boolean,
    secondColor: Boolean,
    loader: Boolean,
    contrast: Boolean,
    thinText: Boolean,
    outline: Boolean,
    dashed: Boolean,
    disabled: Boolean,
  },
  computed: {
    isRouterLink() {
      const URL = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
      return !URL.test(this.href);
    },
  },
};
